<template>
    <img id="BackButton" v-if="!excludeOnPages" class="remove-from-pdf" src="@/assets/img/ui/back-button.svg" @click="navigateToHomePage">
</template>
<script>
export default {
    name: "BackButton",
    methods: {
        navigateToHomePage() {
            this.$emit('closeNavigation')
            let navigateTo = app.manifest.data.custom.find(c => c.type === "customLogoNavigation").data.logoNavigatesTo;
            app.manifest.navigateToRoute(app.manifest.getRouteFromID(navigateTo))
        }
    },
    computed: {
        excludeOnPages() {
            let hide = false;
            let pages = app.manifest.data.custom.find(component => component.type === "excludeNavigationOn").data.pages.map(page => {
                return app.manifest.getRouteFromID(page.page);
            })

            pages.forEach(page => {
                if(window.app.vm.$route.path == page)
                    hide = true;
            })
            
            return hide;
        }
    }
}
</script>
<style lang="scss" scoped>
    @import '@/assets/sass/_responsiveness.scss';

    #BackButton {
        position: fixed;
        bottom: 0;
        z-index: 2;
        transform: translateX(-50%);
        left: calc(50% - (var(--content-max-width) / 1.5));
        cursor: pointer;

        @include tablet-down {
            left: 50%;
        }
    }
</style>